import styles from './typography.module.css'

export const typographyType = {
    title1: styles.typographyTitle1,
    title2: styles.typographyTitle2,
    headline1: styles.typographyHeadline1,
    headline2: styles.typographyHeadline2,
    body1: styles.typographyBody1,
    body2: styles.typographyBody2,
    body3: styles.typographyBody3,
    body4: styles.typographyBody4,
    body5: styles.typographyBody5,
    bodyAccent1: styles.typographyBodyAccent1,
    bodyAccent2: styles.typographyBodyAccent2,
    bodyAccent3: styles.typographyBodyAccent3,
    bodyAccent4: styles.typographyBodyAccent4,
    bodyAccent5: styles.typographyBodyAccent5,
    button1: styles.typographyButton1,
    button2: styles.typographyButton2,
    tag: styles.typographyTag,
    tagAccent: styles.typographyTagAccent,
    uppercase: styles.typographyUppercase,
    link: styles.typographyLink,
    caption: styles.typographyCaption,
    addition:styles.typographyAdditionDescription,
}
export const typographyColor = {
    accent: styles.colorAccent, // #6f338b
    contrast: styles.colorContrast, // #ffffff
    primary: styles.colorPrimary, // #21193d
    secondary: styles.colorSecondary, // #645e77
    tertiary: styles.colorTertiary, // #e9e8ec
    quaternary: styles.colorQuaternary, // #a6a3b1
    tertiaryLight: styles.colorTertiaryLight,
    secondaryInverted: styles.colorSecondaryInverted, // #f6f6f7
    interactionPrimary: styles.colorInteractionPrimary, //#380053
    primaryInverted: styles.colorPrimaryInverted, //#F6F2F8
    error: styles.colorError,
    success: styles.colorSuccess,
}
export const typographyAs = {
    span: "span",
    p: "p",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    div: "div",
    a: "a",
}
